var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SkillStatus } from '../../constants/statuses';
var STATUSES = [
    SkillStatus.Mastered,
    SkillStatus.Developing,
    SkillStatus.HelpNeeded,
    SkillStatus.NoData,
];
var createGradeSkillsSummary = function (students, skills) {
    return STATUSES.reduce(function (acc, status) {
        var _a;
        var studentsSummary = [];
        students.forEach(function (student) {
            var studentSkills = student.skills.filter(function (el) {
                return skills.some(function (skill) { return skill.id === el.skillId; });
            });
            var skillsCount = 0;
            if (status === 'no_data') {
                skillsCount = skills.length - studentSkills.length;
            }
            else {
                skillsCount = studentSkills.reduce(function (count, studentSkill) {
                    if (studentSkill.status === status)
                        return count + 1;
                    return count;
                }, 0);
            }
            if (skillsCount > 0) {
                studentsSummary.push({
                    id: student.id,
                    name: student.name,
                    skillsCount: skillsCount,
                });
            }
        });
        return __assign(__assign({}, acc), (_a = {}, _a[status] = studentsSummary, _a));
    }, {});
};
var checkIfGradeDeveloping = function (grade, students) {
    return grade.skills.some(function (skill) {
        var studentsWithSkillInProgress = students.filter(function (student) {
            return student.skills.some(function (el) {
                return el.skillId === skill.id &&
                    [SkillStatus.Developing, SkillStatus.HelpNeeded].includes(el.status);
            });
        });
        return studentsWithSkillInProgress.length > 0;
    });
};
var checkIfSomeStudentsWithoutPlacementHaveProgressInGrade = function (grade, students) {
    return grade.skills.some(function (skill) {
        var studentsWithSkillInProgress = students.filter(function (student) {
            return !student.placementGrade &&
                student.curriculumGrade === grade.shortName &&
                student.skills.some(function (el) {
                    return el.skillId === skill.id &&
                        [
                            SkillStatus.Mastered,
                            SkillStatus.Developing,
                            SkillStatus.HelpNeeded,
                        ].includes(el.status);
                });
        });
        return studentsWithSkillInProgress.length > 0;
    });
};
var sortGrades = function (grade1, grade2) {
    return grade1.value - grade2.value;
};
var getDomainSkillsInGrade = function (domain, grade) {
    return grade.skills.filter(function (el) { return el.domainId === domain.id; });
};
var checkIfGradeNeedsToIncludeInDomain = function (_a) {
    var grade = _a.grade, domainSkillsInGrade = _a.domainSkillsInGrade, students = _a.students, minPlacementGradeValue = _a.minPlacementGradeValue;
    return ((typeof minPlacementGradeValue === 'number' &&
        grade.value >= minPlacementGradeValue) ||
        checkIfGradeDeveloping(__assign(__assign({}, grade), { skills: domainSkillsInGrade }), students) ||
        checkIfSomeStudentsWithoutPlacementHaveProgressInGrade(grade, students));
};
var filterDomainGradesByPlacement = function (_a) {
    var domain = _a.domain, grades = _a.grades, students = _a.students, minPlacementGradeValue = _a.minPlacementGradeValue;
    var result = [];
    var needToInclude = false;
    grades.sort(sortGrades).forEach(function (grade) {
        var domainSkillsInGrade = getDomainSkillsInGrade(domain, grade);
        if (domainSkillsInGrade.length === 0)
            return;
        if (needToInclude) {
            result.push(grade);
            return;
        }
        if (checkIfGradeNeedsToIncludeInDomain({
            grade: grade,
            domainSkillsInGrade: domainSkillsInGrade,
            students: students,
            minPlacementGradeValue: minPlacementGradeValue,
        })) {
            needToInclude = true;
            result.push(grade);
        }
    });
    return result;
};
var mapGrade = function (_a) {
    var grade = _a.grade, domain = _a.domain, students = _a.students;
    var skills = grade.skills.filter(function (el) { return el.domainId === domain.id; });
    var data = createGradeSkillsSummary(students, skills);
    return {
        id: grade.id,
        value: grade.value,
        shortName: grade.shortName,
        totalSkills: skills.length * students.length,
        data: data,
    };
};
var mapSkillsSummary = function (_a) {
    var domains = _a.domains, groupSkills = _a.groupSkills, minPlacementGradeValue = _a.minPlacementGradeValue;
    var grades = groupSkills.grades, students = groupSkills.students;
    return domains.map(function (domain) {
        var domainGrades = filterDomainGradesByPlacement({
            domain: domain,
            grades: grades,
            students: students,
            minPlacementGradeValue: minPlacementGradeValue,
        }).map(function (grade) { return mapGrade({ grade: grade, domain: domain, students: students }); });
        return {
            id: domain.id,
            name: domain.name,
            grades: domainGrades,
        };
    });
};
var getSkillsCount = function (data) {
    return data.reduce(function (acc, current) { return acc + current.skillsCount; }, 0);
};
export { mapSkillsSummary, getSkillsCount };
